<template>
<w-sliding-popup ref="periodPopup" width="960px" :title="title" @close="onClosePopup">
  <div class="comparison" slot="content">
    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane label="일/주/월/년" name="relative">
        <w-period-relative-view :rscInfoList="rscInfoList" />
      </el-tab-pane>
      <el-tab-pane label="기간선택" name="absolute">
        <w-period-absolute-view :rscInfoList="rscInfoList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</w-sliding-popup>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import WPeriodRelativeView from './PeriodRelativeView';
import WPeriodAbsoluteView from './PeriodAbsoluteView';

export default {
  name: 'WResourceComparePeriodPopup',
  components: {
    WPeriodRelativeView,
    WPeriodAbsoluteView,
  },
  props: {
    rscInfoList: {
      type: Array,
    },
  },
  data() {
    return {
      activeTab: 'relative',
      rscItems: [],
      title: '',
    };
  },
  watch: {
    rscInfoList: {
      handler(rscInfoList) {
        if (!isEmpty(rscInfoList)) {
          let label = '평균';
          if (rscInfoList.statType === 'MAX') {
            label = '최대';
          } else if (rscInfoList.statType === 'MIN') {
            label = '최소';
          }
          this.title = !isEmpty(rscInfoList.statType) ? `기간비교 그래프 (${label})` : '기간비교 그래프';
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [기간비교 그래프] 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.activeTab = 'relative';
      this.$refs.periodPopup.visible = true;
    },
    /**
     * [기간비교 그래프] 팝업창을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.$refs.periodPopup.visible = false;
      this.activeTab = 'relative';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/ResourceComparePeriodPopup/index.vue